import { I18nComponente } from "@/types/gerais"

export const usarDataHorai18n: I18nComponente = {
  "pt-BR": {
    as: "às",
    diasDaSemana: {
      seg: "segunda",
      ter: "terça",
      qua: "quarta",
      qui: "quinta",
      sex: "sexta",
      sab: "sábado",
      dom: "domingo",
    },
    meses: {
      jan: "jan",
      fev: "fev",
      mar: "mar",
      abr: "abr",
      mai: "mai",
      jun: "jun",
      jul: "jul",
      ago: "ago",
      set: "set",
      out: "out",
      nov: "nov",
      dez: "dez",
    },
    valorDoIntervaloDeveSerUmNumeroInteiro: "O valor do intervalo deve ser um número inteiro",
    dataUmNaoPodeSerVazia: "A data 1 não pode ser vazia",
  },
  "es-CO": {
    as: "a las",
    diasDaSemana: {
      seg: "lunes",
      ter: "martes",
      qua: "miércoles",
      qui: "jueves",
      sex: "viernes",
      sab: "sábado",
      dom: "domingo",
    },
    meses: {
      jan: "ene",
      fev: "feb",
      mar: "mar",
      abr: "abr",
      mai: "may",
      jun: "jun",
      jul: "jul",
      ago: "ago",
      set: "sep",
      out: "oct",
      nov: "nov",
      dez: "dic",
    },
    valorDoIntervaloDeveSerUmNumeroInteiro: "El valor del intervalo debe ser un número entero",
    dataUmNaoPodeSerVazia: "La fecha 1 no puede estar vacía",
  },
}
